// extracted by mini-css-extract-plugin
module.exports = {"singleFileStyle":"_1wtI-3JBY5iUnOwHATyHVN"};